// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YT04","label":"styles_label__3P3Wk"};